import {Action, action} from 'easy-peasy';


export interface UserPreferences {
    helpInformation: boolean;
    dataAnonymized: boolean;
    menuMinified: boolean;
    sendReports: boolean;
    autoScrollEventView: boolean;
    autoScrollSearchView: boolean;
    autoScrollTextSamples: boolean;
}

export interface UserPreferencesStoreModel {
    preferences: UserPreferences;
    loadUserPreferences: Action<UserPreferencesStoreModel, UserPreferences>;
    loading: boolean;
    setLoading: Action<UserPreferencesStoreModel, boolean>;
}

export default <UserPreferencesStoreModel>{
    preferences: {},
    loadUserPreferences: action((state, userPreferences) => {
        state.preferences = userPreferences;
    }),
    loading: false,
    setLoading: action((state, loading) => {
        state.loading = loading;
    }),
};
